import {useQueryParams} from 'presentation/pages/private/hooks';
import {getSpecialtyBySearch} from 'presentation/utils/GetSpecialtyBySearch';
import {MOST_SEARCHED} from 'presentation/modules/booking/shared/constants/mostSearched';

import {UseMostSearchedListProps} from './types';
import {textHandle} from 'presentation/utils/textHandle';

export function useMostSearchedList({flowType, mostSearchedArr}: UseMostSearchedListProps) {
	const {SEARCH_PARAMS} = useQueryParams();
	const {query, searchByLetter} = SEARCH_PARAMS;

	const sanitizedQuery = query ? textHandle(query).sanitizeText() : '';
	const specialtySearchTerm = query ? getSpecialtyBySearch({text: sanitizedQuery, flowType}) : '';

	const filteredMostSearched = (mostSearchedArr || []).filter(specialty => {
		const formattedText = textHandle(specialty?.formattedText).sanitizeText();
		const matchesQuery = query ? formattedText?.includes(specialtySearchTerm) : true;
		const matchesLetter = searchByLetter
			? formattedText?.startsWith(searchByLetter?.toLowerCase()) ||
				(['d', 'n'].includes(searchByLetter?.toLowerCase()) &&
					specialty?.code === MOST_SEARCHED?.headache?.code)
			: true;

		return matchesQuery && matchesLetter;
	});

	return {
		filteredMostSearched,
	};
}
